import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/public/assets/images/hero/hero-3.webp");
;
import(/* webpackMode: "eager", webpackExports: ["Form"] */ "/workspace/src/sections/contact/v2/form/index.tsx");
